import { useState } from "react";
import { XMarkIcon, XCircleIcon } from "@heroicons/react/20/solid";

export function Alert({ code, message }) {
  const [isVisible, setIsVisible] = useState(true);

  const getErrorMessage = (statusCode) => {
    switch (statusCode) {
      case 400:
        return "Oops! There was an issue with the request. Please review your input and try again.";
      case 401:
        return "You are not authorized to view this content. Please log in and try again.";
      case 403:
        return "It seems you don't have permission to access this resource.";
      case 404:
        return "We couldn't find what you were looking for. Please check the URL.";
      case 500:
        return "Something went wrong on our end. We're working to fix it as soon as possible.";
      case 503:
        return "The service is temporarily unavailable. Please try again later.";
      default:
        return "An unexpected error occurred. Please refresh the page or come back later.";
    }
  };

  if (!isVisible || (!code && !message)) return null;

  return (
    <div className="rounded-md bg-red-50 p-4 mb-4">
      <div className="flex items-start items-center">
        <div className="flex-shrink-0">
          <XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true" />
        </div>
        <div className="ml-3 flex-1">
          <p className="text-sm font-medium text-red-800">
            {message || getErrorMessage(code)}
          </p>
        </div>
        <div className="ml-4 flex-shrink-0">
          <button
            onClick={() => setIsVisible(false)}
            type="button"
            className="inline-flex rounded-md bg-red-50 p-1.5 text-red-500 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-red-600 focus:ring-offset-2 focus:ring-offset-red-50"
          >
            <span className="sr-only">Dismiss</span>
            <XMarkIcon className="h-5 w-5" aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  );
}
